import getFuturePeriod from "./get-future-period";

export default function getFutureVolume({ state, getters }) {
  if (!getters.containerLoaded) {
    return null;
  }

  return getFuturePeriod(state.container.volumes);
}
